import React from 'react';
import ResultSection1 from './ResultSection1';
import ResultSection2 from './ResultSection2';

const ResultInfo = () => {
    return (
        <>
            <ResultSection1 />
            <ResultSection2 />
        </>
    );
}

export default ResultInfo;